const JobsthemeColorsData = [
    {
        id: 2,
        jobstheme: "#FC7336",
        btntheme: "#E16A36",
        statusbg: "#D6541A",
    },
    {
        id: 3,
        jobstheme: "#1DCCA8",
        btntheme: "#16B493",
        statusbg: "#11A082",
    },
    {
        id: 4,
        jobstheme: "#62D647",
        btntheme: "#49D128",
        statusbg: "#47A531",
    },
    {
        id: 5,
        jobstheme: "#51344D",
        btntheme: "#462E42",
    },
    {
        id: 6,
        jobstheme: "#23B5D3",
        btntheme: "#16A6C4",
    },
    {
        id: 7,
        jobstheme: "#F4E869",
        btntheme: "#E4D85D",
    },
    {
        id: 8,
        jobstheme: "#FDDBBB",
        btntheme: "#D1B59C",
    },
    {
        id: 9,
        jobstheme: "#FFB26F",
        btntheme: "#D99D66",
    },
    {
        id: 10,
        jobstheme: "#C5D3E8",
        btntheme: "#A2B2C9",
    },
    {
        id: 11,
        jobstheme: "#DE7C7D",
        btntheme: "#CB6D6E",
    },
    {
        id: 12,
        jobstheme: "#D0E8C5",
        btntheme: "#B5CBAC",

    },
    {
        id: 13,
        jobstheme: "#E8BCB9",
        btntheme: "#CCA3A0",
    },
    {
        id: 14,
        jobstheme: "#6A9AB0",
        btntheme: "#5A8091",
    },
    {
        id: 15,
        jobstheme: "#AA69CC",
        btntheme: "#9458B4",
    },
    {
        id: 16,
        jobstheme: "#DFD3C3",
        btntheme: "#C1B5A6",
    },
];
export default JobsthemeColorsData;